"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("react-bootstrap/Button"));
var _CompletedContext = require("../CompletedContext");
require("./TaskTree.css");
var TaskTree = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(TaskTree, _React$Component);
  var _super = (0, _createSuper2.default)(TaskTree);
  function TaskTree(props) {
    var _this;
    (0, _classCallCheck2.default)(this, TaskTree);
    _this = _super.call(this, props);
    _this.state = props.state || {};
    if (!_this.state.initialized) {
      _this.state.initialized = true;
      // Initial state is set here, since the constructor can be called more than once.
      _this.state.completed = _this.props.paths ? _this.props.paths.length === 0 : false;
    }
    return _this;
  }
  (0, _createClass2.default)(TaskTree, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }
      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        // Keep our stored state synchronized
        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
    }
  }, {
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      // Notify the parent of our completion status
      this.context.registerTask(function (id) {
        _this2.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      return /*#__PURE__*/_react.default.createElement("div", {
        key: this.props.key,
        className: "task task-tree",
        id: this.props.id
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "content"
      }, this.props.children), /*#__PURE__*/_react.default.createElement("div", {
        className: "buttons" + (this.state.completed ? " disabled" : "")
      }, this.props.paths.map(function (path, index) {
        return /*#__PURE__*/_react.default.createElement(_Button.default, Object.assign({
          key: index,
          children: "Path ".concat(index),
          active: _this3.state.path === index,
          "aria-pressed": _this3.state.path === index,
          "aria-disabled": _this3.state.completed
        }, path.buttonProps, {
          onClick: function onClick() {
            if (_this3.state.completed) return;
            _this3.setState({
              path: index
            });
          }
        }));
      })), this.state.path !== undefined && !this.state.completed && /*#__PURE__*/_react.default.createElement("div", {
        className: "continue"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, Object.assign({
        children: "Continue"
      }, this.props.continueProps, {
        onClick: function onClick() {
          _this3.setState({
            completed: true
          });
        }
      }))), this.state.completed && this.props.paths[this.state.path] && this.props.paths[this.state.path].content);
    }
  }]);
  return TaskTree;
}(_react.default.Component);
exports.default = TaskTree;
TaskTree.contextType = _CompletedContext.CompletedContext;